import {qs, qsArray} from './utilities/index';

let Overlay = function () {
    if (Overlay.prototype._singletonInstance) {
        return Overlay.prototype._singletonInstance;
    }
    Overlay.prototype._singletonInstance = this;

    this.initialize();
}

Overlay.prototype.initialize = function () {

    let self = this;

    let importantOverlay = document.getElementById('important-overlay');
    let importantOverlayBg = qs('.overlay-bg', importantOverlay);
    let importantOverlayClose = qs('.close-button', importantOverlay);

    this.openImportantWindow = function (id) {
        importantOverlay.setAttribute('data-question-id', id);
        importantOverlay.classList.add('is-active');
        importantOverlay.clientHeight;
        importantOverlay.classList.add('is-visible');
        importantOverlayBg.addEventListener('click', this.closeImportantWindow);
        importantOverlayClose.addEventListener('click', this.closeImportantWindow);
    };

    this.closeImportantWindow = function () {
        importantOverlayBg.removeEventListener('click', this.closeImportantWindow);
        importantOverlayClose.removeEventListener('click', this.closeImportantWindow);
        importantOverlay.classList.remove('is-visible');
        setTimeout(function() {
            importantOverlay.classList.remove('is-active');
        }, 300);
    }

    let compareOverlay = document.getElementById('compare-overlay');
    // let compareOverlayBg = qs('.overlay-bg', compareOverlay);
    let compareOverlayClose = qs('.close-button', compareOverlay);

    this.setCompareIrons = function(iron1, iron2) {
        let optimal = qs('.is-optimal', compareOverlay);
        let alternative = qs('.is-alternative', compareOverlay);
        if (optimal) {
            optimal.classList.remove('is-optimal');
            alternative.classList.remove('is-alternative');
        }
        optimal = qs('[data-iron="' + iron1 + '"]', compareOverlay);
        alternative = qs('[data-iron="' + iron2 + '"]', compareOverlay);
        optimal.classList.add('is-optimal');
        alternative.classList.add('is-alternative');
    }

    let compareOverlayCallback = null;
    this.openCompareOverlay = function (cb) {
        compareOverlayCallback = cb;
        compareOverlay.classList.add('is-active');
        compareOverlay.clientHeight;
        compareOverlay.classList.add('is-visible');
        compareOverlayClose.addEventListener('click', this.closeCompareWindow);
    }

    this.closeCompareWindow = function () {
        compareOverlayClose.removeEventListener('click', this.closeCompareWindow);
        compareOverlay.classList.remove('is-visible');
        setTimeout(function() {
            compareOverlay.classList.remove('is-active');
            compareOverlayCallback();
            compareOverlayCallback = null;
        }, 300);
    }

    let whyOverlay = document.getElementById('why-overlay');
    let whyOverlayBg = qs('.overlay-bg', whyOverlay);
    let whyOverlayClose = qs('.close-button', whyOverlay);

    this.openWhyWindow = function (id) {
        whyOverlay.setAttribute('data-iron-id', id);
        whyOverlay.classList.add('is-active');
        whyOverlay.clientHeight;
        whyOverlay.classList.add('is-visible');
        whyOverlayBg.addEventListener('click', this.closeWhyWindow);
        whyOverlayClose.addEventListener('click', this.closeWhyWindow);
    };

    this.closeWhyWindow = function () {
        whyOverlayBg.removeEventListener('click', this.closeWhyWindow);
        whyOverlayClose.removeEventListener('click', this.closeWhyWindow);
        whyOverlay.classList.remove('is-visible');
        setTimeout(function() {
            whyOverlay.classList.remove('is-active');
        }, 300);
    }

    let mpiOverlay = document.getElementById('mpi-overlay');
    let mpiOverlayBg = qs('.overlay-bg', mpiOverlay);
    let mpiOverlayClose = qs('.close-button', mpiOverlay);
    let mpiOverlayValue = qs('.mpi-value', mpiOverlay);

    this.openMPIWindow = function (mpi) {
        mpiOverlayValue.textContent = mpi;
        mpiOverlay.classList.add('is-active');
        mpiOverlay.clientHeight;
        mpiOverlay.classList.add('is-visible');
        mpiOverlayBg.addEventListener('click', this.closeMPIWindow);
        mpiOverlayClose.addEventListener('click', this.closeMPIWindow);
    };

    this.closeMPIWindow = function () {
        mpiOverlayBg.removeEventListener('click', this.closeMPIWindow);
        mpiOverlayClose.removeEventListener('click', this.closeMPIWindow);
        mpiOverlay.classList.remove('is-visible');
        setTimeout(function() {
            mpiOverlay.classList.remove('is-active');
        }, 300);
    }

    let mpiButtons = qsArray('.mpi-button');
    mpiButtons.forEach(function (btn) {
        let mpi = qs('.mpi-button-value', btn);
        btn.addEventListener('click', function() {
            self.openMPIWindow(mpi.innerText);
        });
    });

    let attrOverlay = document.getElementById('attribute-overlay');
    let attrOverlayBg = qs('.overlay-bg', attrOverlay);
    let attrOverlayClose = qs('.close-button', attrOverlay);

    this.openAttrWindow = function (id) {
        attrOverlay.setAttribute('data-attribute-id', id);
        attrOverlay.classList.add('is-active');
        attrOverlay.clientHeight;
        attrOverlay.classList.add('is-visible');
        attrOverlayBg.addEventListener('click', this.closeAttrWindow);
        attrOverlayClose.addEventListener('click', this.closeAttrWindow);
    };

    this.closeAttrWindow = function () {
        attrOverlayBg.removeEventListener('click', this.closeAttrWindow);
        attrOverlayClose.removeEventListener('click', this.closeAttrWindow);
        attrOverlay.classList.remove('is-visible');
        setTimeout(function() {
            attrOverlay.classList.remove('is-active');
        }, 300);
    }

    let attrButtons = qsArray('.overlay-attribute-btn');
    attrButtons.forEach(function (btn) {
        btn.addEventListener('click', function() {
            self.openAttrWindow(btn.getAttribute('data-attribute'));
        });
    });

    let resultsOverlay = document.getElementById('send-results-overlay');
    let resultsOverlayBg = qs('.overlay-bg', resultsOverlay);
    let resultsOverlayClose = qsArray('.close-button', resultsOverlay);
    let resultsForm = qs('form', resultsOverlay);
    let emailInput = resultsForm.querySelector('input#email');
    let emailSuccess = resultsOverlay.querySelector('#success-email');
    let submitButton = resultsForm.querySelector('#submit');
    self.primaryId = '';
    self.alternateId = '';
    self.primaryFIid = '';
    self.alternateFIid = '';
    // let self = this;

    resultsForm.addEventListener('submit', function (e) {
        debugger;
        e.preventDefault();
        if(submitButton.getAttribute('aria-disabled') === 'false')
        {
            console.log('send results submitted ', emailInput.value);

            if (emailInput.value === '') {
                return;
            }
            window.submitResultsForm(emailInput.value, self.primaryId, self.alternateId, self.primaryFIid, self.alternateFIid);
            submitButton.setAttribute('aria-disabled', 'true');
            //submitButton.disabled = true;
            submitButton.classList.add('disabled');
        }
    }, true);

    emailInput.addEventListener('input', function (e) {
        console.log('email changed ' + emailInput.value)
        if (emailInput.value === '' && submitButton.getAttribute('aria-disabled') === 'false') {
            // console.log('disabled submit button');
            submitButton.classList.add('disabled');
            submitButton.setAttribute('aria-disabled', 'true');
        } else if (emailInput.value !== '' && submitButton.getAttribute('aria-disabled') === 'true') {
            submitButton.setAttribute('aria-disabled', 'false');
            submitButton.classList.remove('disabled');
            // console.log('enabled submit button');
        }
    })

    this.showResultsError = function () {
        resultsOverlay.setAttribute('data-step-id', 'error');
    }

    this.setInitialEmailValue = function (email) {
        emailInput.value = email
        if (emailInput.value !== '' && submitButton.getAttribute('aria-disabled') === 'true') {
            submitButton.setAttribute('aria-disabled', 'false');
            submitButton.classList.remove('disabled');
            // console.log('enabled submit button');
        }
    }

    this.showResultsSuccess = function () {
        emailSuccess.innerHTML = emailInput.value;
        resultsOverlay.setAttribute('data-step-id', 'success');
    }

    this.openSendResults = function (id, primaryId, alternateId, primaryFIid, alternateFIid) {
        console.log('Overlay.openSendResults ' + id + ', ' + primaryId + ', ' + alternateId);
        self.primaryId = primaryId;
        self.alternateId = alternateId;
        self.primaryFIid = primaryFIid;
        self.alternateFIid = alternateFIid;
        resultsOverlay.setAttribute('data-step-id', id);
        resultsOverlay.classList.add('is-active');
        resultsOverlay.clientHeight;
        resultsOverlay.classList.add('is-visible');
        // submitButton.disabled = false;
        // submitButton.classList.remove('disabled');
        if (emailInput.value === '' &&  submitButton.getAttribute('aria-disabled') === 'false') {
            // console.log('disabled submit button');
            submitButton.classList.add('disabled');
            //submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');
        }
        resultsOverlayBg.addEventListener('click', this.closeSendResults);
        resultsOverlayClose.forEach(function(el) {
            el.addEventListener('click', self.closeSendResults);
        });
    }

    this.closeSendResults = function () {
        resultsOverlayBg.removeEventListener('click', this.closeSendResults);
        resultsOverlayClose.forEach(function(el){
            el.removeEventListener('click', self.closeSendResults);
        });
        resultsOverlay.classList.remove('is-visible');
        setTimeout(function() {
            resultsOverlay.classList.remove('is-active');
        }, 300);
    }
}

export default Overlay;
